import React, { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
  roles?: string[];
}

const PrivateRoute = ({ children, roles }: PrivateRouteProps): ReactElement => {
  const { isAuthenticated, user,login } = useAuth();

  if (!isAuthenticated) {
    login();
    return <></>;
  }

  if (roles && (!user?.roles || !user.roles.some(r => roles.includes(r)))) {
    return <Navigate to="/unauthorized" />;
  }

  return <>{children}</>;
};

export default PrivateRoute;